// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import MessageOutlinedSvg from "@ant-design/icons-svg/es/asn/MessageOutlined";
import AntdIcon from '../components/AntdIcon';

var MessageOutlined = function MessageOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: MessageOutlinedSvg
  }));
};

MessageOutlined.displayName = 'MessageOutlined';
export default /*#__PURE__*/React.forwardRef(MessageOutlined);